import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function RequireAuth({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm">
                Cargando sesión…
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return children;
}

export function RequireRole({ roles, children }) {
    const { hasRole, user } = useAuth();
    if (!user) return <Navigate to="/login" replace />;
    if (!hasRole(roles)) {
        return <Navigate to="/403" replace />;
    }
    return children;
}

export function RequireSuperAdmin({ children }) {
    const { user } = useAuth();
    if (!user) return <Navigate to="/login" replace />;
    if (!user.super_admin) {
        return <Navigate to="/403" replace />;
    }
    return children;
}
